import { connect } from "react-redux";
import { apiUrl } from "@ai360/core";

import { requestSearchString, fetchEntities } from "./../actions";
import { getUserRoles, getFilteredUserRoles } from "./../selectors";

const autoSearchUrl = apiUrl("SetupZapper/GetUserRoleAutoCompleteList");
const autoSearchModelName = "filteredUserRoles";

const entitiesUrl = apiUrl("SetupZapper/GetUserRoles");
const entitiesModelName = "userRoles";

const mapDispatchToProps = (dispatch) => ({
    // This action is dispatched using needs hoc
    getEntities: (data) => fetchEntities({ data, url: entitiesUrl, modelName: entitiesModelName }),
    searchEntity: (searchString, companyUserGuid) =>
        dispatch(
            requestSearchString({
                searchString,
                companyUserGuid,
                url: autoSearchUrl,
                modelName: autoSearchModelName,
            })
        ),
});

const mapStateToProps = (state) => ({
    entities: getUserRoles(state),
    filteredData: getFilteredUserRoles(state),
});

const WithUserRoles = (View) => {
    return connect(mapStateToProps, mapDispatchToProps)(View);
};

export default WithUserRoles;
